import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';

import { startIssue } from '../../api/issues.api';
import { holdingAfter } from '../../domain/claims';
import type { IssueStartResult, StartSource } from '../../types/domain.types';
import { ctlMutationKeys } from '../../utils/query-keys';
import { holdIssue, refreshIssue } from '../logic/issueQuery';

import { markIssueStarted, refreshAfterStart } from './startCache';

export type StartIssueMutation = UseMutationResult<IssueStartResult, Error, StartSource>;

export const useStartIssue = (issueId: string): StartIssueMutation => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ctlMutationKeys.startIssue(issueId),
    networkMode: 'always',
    mutationFn: (source: StartSource) => startIssue(issueId, source),
    onSuccess: async (result) => {
      const holding = holdingAfter(result);
      if (holding === null) return;
      await Promise.all([markIssueStarted(queryClient, issueId, holding), holdIssue(queryClient, issueId, holding)]);
    },
    onSettled: () => {
      refreshAfterStart(queryClient);
      refreshIssue(queryClient, issueId);
    },
  });
};
